import {
  ListItemIcon as MUIListItemIcon,
  ListItemIconProps,
} from '@mui/material';
export const ListItemIcon = ({ ...props }: ListItemIconProps) => (
  <MUIListItemIcon {...props} />
);
